import posthog from 'posthog-js';
import type { ICockpitConfig } from '@/types';

let initialized = false;
let identifiedThisSession = false;

export function initPostHog(config: ICockpitConfig): boolean {
    if (initialized || !config.POSTHOG_KEY?.trim() || !config.POSTHOG_HOST?.trim()) {
        return initialized;
    }
    try {
        posthog.init(config.POSTHOG_KEY, {
            api_host: config.POSTHOG_HOST,
            person_profiles: 'identified_only',
            capture_pageview: false,
            disable_session_recording: true,
        });
        initialized = true;
        return true;
    } catch {
        return false;
    }
}

export function isPostHogEnabled(): boolean {
    return initialized;
}

export interface IdentifyUserProps {
    email?: string;
    company_name?: string;
}

export function identifyUser(userId: number | string | undefined, props?: IdentifyUserProps): void {
    if (!initialized || identifiedThisSession || userId == null) return;
    try {
        const personProps = props && Object.keys(props).length > 0 ? props : undefined;
        posthog.identify(String(userId), personProps);
        identifiedThisSession = true;
    } catch {
        // no-op
    }
}

export function capturePageView(path: string, routeName?: string | symbol | null): void {
    if (!initialized) return;
    try {
        posthog.capture('$pageview', {
            path,
            route_name: routeName != null && routeName !== '' ? String(routeName) : undefined,
        });
    } catch {
        // no-op
    }
}
